<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <section v-if="order !== undefined">
      <div v-if="order">
        <div class="alert alert-success" role="alert" v-if="order.prcode == 0">
          Platba ve výši {{prachy_bez_00(order.amount)}} Kč úspěšně dokončena, děkujeme vám.
        </div>
        <div class="alert alert-danger" role="alert" v-else>
          <p>Platba ve výši {{prachy_bez_00(order.amount)}} Kč nebyla dokončena.</p>
          <p>
            <b>{{prcodeText()}}</b><br>
            <small>PRCODE={{order.prcode}}</small>
          </p>
          <p v-if="order.srcode">
            Důvod: <b>{{srcodeText1()}}</b><br>
            <i>{{srcodeText2()}}</i><br>
            <small>SRCODE={{order.srcode}}</small>
          </p>
          <div v-if="order.amount > 0">
            <button class="btn btn-primary" v-on:click="tryAgain()" :disabled="createOrderPending">zkusit znovu</button>
            <button class="btn btn-secondary" v-on:click="$router.push('/account')" :disabled="createOrderPending">zrušit</button>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import GpWebpayResource from '../backend-resources/gp-webpay-resource'

const PRCODES = {
  0: 'OK',
  1: 'Pole příliš dlouhé',
  2: 'Pole příliš krátké',
  3: 'Chybný obsah pole',
  4: 'Pole je prázdné',
  5: 'Chybí povinné pole',
  6: 'Pole neexistuje',
  11: 'Neznámý obchodník',
  14: 'Duplikátní číslo platby',
  15: 'Objekt nenalezen',
  16: 'Částka k autorizaci překročila původní částku platby',
  17: 'Částka k zaplacení překročila povolenou (autorizovanou) částku',
  18: 'Součet vracených částek překročil zaplacenou částku',
  20: 'Objekt není ve stavu odpovídajícím této operaci',
  25: 'Uživatel není oprávněn k provedení operace',
  26: 'Technický problém při spojení s autorizačním centrem',
  27: 'Chybný typ platby',
  28: 'Zamítnuto v 3D Secure',
  30: 'Zamítnuto v autorizačním centru',
  31: 'Chybný podpis',
  32: 'Expirovaná karta',
  33: 'Originální/Master platba není autorizovaná',
  34: 'Originální/Master platbu nelze použít pro následné platby',
  35: 'Expirovaná session (vypršení času při zadávání karty)',
  38: 'Nepodporovaná karta',
  40: 'Zamítnuto ve Fraud detection system',
  50: 'Držitel karty zrušil platbu',
  80: 'Duplicitní MessageId',
  82: 'V HSM chybí název šifrovacího klíče',
  83: 'Operace zrušena vydavatelem',
  84: 'Duplicitní hodnota',
  85: 'Zakázáno na základě pravidel obchodníka',
  200: 'Žádost o doplňující informace',
  300: 'Podmíněně zamítnuto – vydavatel požaduje SCA',
  1000: 'Technický problém'
}

const SRCODES = {
  /* Doplnujici texty pro 28: 'Zamítnuto v 3D Secure' */
  3000: ['Neověřeno v 3D. Vydavatel karty není zapojen do 3D nebo karta nebyla aktivována.',
    'Ověření držitele karty bylo neúspěšné (neplatně zadané údaje, stornování autentikace, uzavření okna pro autentikaci držitele karty se zpětnou vazbou...).'],

  3001: ['Držitel karty ověřen.',
    'Ověření držitele karty v 3D systémech proběhlo úspěšně. Pokračuje se autorizací platby.'],

  3002: ['Neověřeno v 3D. Vydavatel karty nebo karta není zapojena do 3D.',
    'V 3D systémech nebylo možné ověřit držitele karty – karta, nebo její vydavatel, není zapojen do 3D.'],

  3004: ['Neověřeno v 3D. Vydavatel karty není zapojen do 3D nebo karta nebyla aktivována.',
    'V 3D systémech nebylo možné ověřit držitele karty – karta není aktivována, nebo její vydavatel, není zapojen do 3D.'],

  3005: ['Zamítnuto v 3D.Technický problém při ověření držitele karty.',
    'V 3D systémech nebylo možné ověřit držitele karty – vydavatel karty nepodporuje 3D, nebo technický problém v komunikaci s 3D systémy finančních asociací, či vydavatele karty. V transakci není možné pokračovat, povoleno z důvodu zabezpečení obchodníka před případnou reklamací transakce držitelem karty.'],

  3006: ['Zamítnuto v 3D. Technický problém při ověření držitele karty.',
    'V 3D systémech nebylo možné ověřit držitele karty – technický problém ověření obchodníka v 3D systémech, anebo v komunikaci s 3D systémy finančních asociací, či vydavatele karty.'],

  3007: ['Zamítnuto v 3D. Technický problém v systému zúčtující banky. Kontaktujte obchodníka.',
    'V 3D systémech nebylo možné ověřit držitele karty – technický problém v 3D systémech.'],

  3008: ['Zamítnuto v 3D. Použit nepodporovaný karetní produkt.',
    'Byla použita karta, která není v 3D systémech podporována.'],

  /* Doplnujici texty pro 30: 'Zamítnuto v autorizačním centru' */
  1001: ['karta blokovaná',
    'Pravděpodobné zneužití platební karty – kradená karta, podezření na podvod, ztracená karta apod. Většinou pokus o podvodnou transakci.'],

  1002: ['autorizace zamítnuta',
    'Z autorizace se vrátil důvod zamítnutí “Do not honor“. Vydavatel, nebo finanční asociace zamítla autorizaci BEZ udání důvodu.'],

  1003: ['problém karty',
    'Expirovaná karta, chybné číslo karty, nastavení karty - pro kartu není povoleno použití na internetu, nepovolená karta, expirovaná karta, neplatná karta, neplatné číslo karty, částka přesahuje maximální limit karty, neplatné CVC/CVV, neplatná délka čísla karty, neplatná expirační doba, pro kartu je požadována kontrola PIN.'],

  1004: ['technický problém',
    'Autorizaci není možné provést z technických důvodů – technické problémy v systému vydavatele karty, nebo finančních asociací a finančních procesorů.'],

  1005: ['problém účtu',
    'Nedostatek prostředků na účtu, překročeny limity, překročen max. povolený počet použití.']
}

export default {
  name: 'PaymentFinished',
  data: () => {
    return {
      order: undefined,
      createOrderPending: false,
      displayError: undefined
    }
  },
  created () {
    GpWebpayResource.loadOrder(this.$route.params.ordernumber).then((result) => {
      this.order = result.data
    })
    setTimeout(() => {
      this.$router.push('/account')
    }, 60000)
  },
  methods: {
    prcodeText () {
      return PRCODES[this.order.prcode]
    },
    srcodeText1 () {
      if (SRCODES[this.order.srcode]) {
        return SRCODES[this.order.srcode][0]
      }
    },
    srcodeText2 () {
      if (SRCODES[this.order.srcode]) {
        return SRCODES[this.order.srcode][1]
      }
    },
    tryAgain () {
      this.zaplatitKartou()
    },
    zaplatitKartou () {
      this.createOrderPending = true
      GpWebpayResource.createOrder({amount: this.order.amount})
        .then((result) => {
          if (result.data.goto.startsWith('http')) {
            window.location = result.data.goto
          }
        })
        .catch((error) => {
          console.log(error.response.status)
          if (error.response.status === 500) {
            this.displayError = 'Litujeme, platební brána je dočasně nedostupná. Zkuste to prosím později.'
          } else {
            this.displayError = error.response.status + ' ' + error.response.statusText
          }
        })
        .finally(() => {
          this.createOrderPending = false
        })
    },
    prachy_bez_00: function (kolik) {
      if (kolik === null) return ''
      kolik = parseFloat(kolik)
      if (kolik.toFixed(2).endsWith('.00')) {
        return kolik.toFixed(0)
      } else {
        return kolik.toFixed(2)
      }
    }
  }
}
</script>

<style scoped>
.alert {
  padding: 2rem;
}
</style>



// WEBPACK FOOTER //
// PaymentFinished.vue?9d59f32e